/**
 * get color for tables
 * @param {number} i
 * @returns {string}
 */
const getColor = i => (i == 1 ? 'rgb(95, 95, 89)' : 'white');

export default getColor;
